<template>
<div>
	<modal-dialog
		:modal-visible="visible"
		title="Select a Form Child Template"
		confirm-button-text="Add"
		:submit-visible="false"
		modal-size="modal-lg"
		v-on:closeModal="$emit('closeModal')">

		<form-child-template-selector
			:category-selected="selectedCategory"
			v-on:categorySelected="selectedCategory = $event"
			v-on:childTemplateClick="$emit('childTemplateSelected', $event)">
		</form-child-template-selector>

	</modal-dialog>
</div>
</template>
<script type="text/javascript">

import ModalDialog from "@/components/ModalDialog"
import FormChildTemplateSelector from "@/components/company_forms/FormChildTemplateSelector"


export default {
	name: "FormChildTemplateSelectorModal",
	components: {
		ModalDialog,
		FormChildTemplateSelector
	},
	props: [
		"visible"
	],
	data() {
		return {
			selectedCategory: null
		}
	},
	watch: {
		visible() {
			if (this.visible)
				this.selectedCategory = null
		}
	}
}
</script>